import React, { useEffect, useState } from "react";
import { Modal, Select } from "antd";
const { Option } = Select;

const ZoneModal = (props) => {
  const [zoneId, setZoneId] = useState(null);
  useEffect(() => {
    setZoneId(props.riderZoneId);
  }, [props.riderZoneId]);

  return (
    <Modal
      title={props.RiderName}
      visible={props.assignZoneModal}
      onOk={props.handleOk}
      onCancel={props.handleCancel}
    >
      <Select
        value={props.riderZoneId}
        onChange={props.riderZoneChange}
        placeholder="Select Zone"
        style={{ width: "100%" }}
      >
        {props.postDataZone &&
          props.postDataZone.map((zone) => (
            <Select.Option key={zone._id} value={zone._id}>
              {zone.zoneName}
            </Select.Option>
          ))}
      </Select>
    </Modal>
  );
};

export default ZoneModal;
